import { library } from '@fortawesome/fontawesome-svg-core';
import { faPaperPlane, faBullhorn, faDownload, faTachometerAlt, faExternalLinkAlt,
  faCheck, faHome, faTimesCircle, faStar, faFlag, faMinusCircle, faPlusCircle,
  faCompressAlt, faExpandAlt, faCamera, faDollarSign, faCaretLeft, faCloudUploadAlt, faLongArrowUp, faLongArrowDown } from '@fortawesome/pro-solid-svg-icons'

library.add(faPaperPlane, faBullhorn, faDownload, faTachometerAlt, faExternalLinkAlt,
  faCheck, faHome, faTimesCircle, faStar, faFlag, faMinusCircle, faPlusCircle,
  faCompressAlt, faExpandAlt, faCamera, faDollarSign, faCaretLeft, faCloudUploadAlt, faLongArrowUp, faLongArrowDown);
